export default __webpack_public_path__ + "static/media/adding.446449d0.svg";